
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useReportApi } from '../../resources/hooks/api/useReportApiHook';
import { useSettingsApi } from '../../resources/hooks/api/useSettingsApiHook';
import Select from 'react-select';
import toast from 'react-hot-toast';
import "react-datepicker/dist/react-datepicker.css";
import { MONTHS } from '../../resources/constants';
import { lastYears } from '../../resources/functions';
import { calculateGroupedTotals, currencyFormat } from '../../resources/helper';
import { fileDownloadBlob, usdCurrencyFormat } from '../../resources/functions'
import { getBranch } from '../../store/user/selectors'
import { getAccountSettings } from '../../store/settings/selectors'
import moment from 'moment';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf'
import { useTranslation } from 'react-i18next';
import { Alert } from 'react-bootstrap';
import SAlert from '../../components/SAlert';
import DotLoader from '../../components/DotLoader';
import { SettingsI } from 'store/settings/types';
import ViewRegisterModal from '../../components/Modal/ProfitLoss';

interface Props {

}

const BalanceSheet: React.FC<Props> = () => {
    const { balanceSheetData, balanceSheetRefresh, downloadReport } = useReportApi();
    const { fetchAccountSettingsData } = useSettingsApi();
    const contentRef: any = useRef<HTMLDivElement | null>(null);
    const { t } = useTranslation("scenes.balanceSheet");

    const [glAllAccount, setGlAllAccount] = useState<any[]>([]);
    const [bsRefreshInOrogress, setBsRefreshInOrogress] = useState<number | null>(null)
    const [isNotify, setIsNotify] = useState<boolean>(false);
    const [glBalanceSheetList, setGlBalanceSheetList] = useState<any[]>([]);
    const [searchParams, setSearchParams] = useState<any>({
        month: { value: '01', label: 'January' },
        year: { value: new Date().getFullYear(), label: '' + new Date().getFullYear() }
    });
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isDownloading, setIsDownloading] = useState<boolean>(false);
    const [onHold, setOnHold] = useState<boolean>(false);
    const [showConfirm, setShowConfirm] = useState<boolean>(false);
    const [isThirdPartyEnabled, setIsThirdPartyEnabled] = useState<boolean>(false);
    const [isShowViewRegister, setIsShowViewRegister] = useState<boolean>(false);
    const [companyInfo, setCompanyInfo] = useState<any>(null);
    const [txnRegisterPayload, setTxnRegisterPayload] = useState<{
        startDate: string,
        endDate: string,
        account: number,
        hasEditAccess: boolean
    }>({
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        account: 0,
        hasEditAccess: false
    });

    const branchData = useSelector(getBranch)
    const accountSettings = useSelector(getAccountSettings)

    const fetchBalanceSheetList = () => {
        const params: any = {
            "page": 1,
            "per_page": 5000,
            year: searchParams.year['value'],
            month: searchParams.month['value'],
            branch_id: +branchData['id']
        }

        setIsLoading(true);
        balanceSheetData(params, (message: string, resp: any) => {
            setIsLoading(false);
            if (resp && resp['data'] && resp['data']['data'] && resp['data']['data']['result']) {
                const companyInfo = resp.data.data?.company_details ?? null;
                const calculatedData = calculateGroupedTotals(resp.data.data.result);
                const isThirdPartyEnabled = resp.data.data?.is_third_party_enable ?? false;

                setCompanyInfo(companyInfo);
                setGlBalanceSheetList(calculatedData)
                // setGlBalanceSheetList(resp['data']['data']['result'])
                // if (isThirdPartyEnabled) {
                //     setGlBalanceSheetList(resp['data']['data']['result'])
                // } else {
                //     setGlBalanceSheetList(calculatedData)
                // }
                setIsNotify(resp.data.data?.is_notify || false);
                setIsLoading(false);

                setIsNotify(resp.data.data?.is_notify || false);
                setIsThirdPartyEnabled(isThirdPartyEnabled)
            } else {
                setGlBalanceSheetList([]);
                setIsLoading(false);
            }

        }, (message: string, resp: any) => {
            setGlBalanceSheetList([]);
            setIsLoading(false);
            toast.error(message);
        })
    }

    const refreshBalanceSheetList = () => {
        const params: any = {
            "page": 1,
            "per_page": 5000,
            year: searchParams.year['value'],
            month: searchParams.month['value'],
            branch_id: +branchData['id']
        }

        setIsLoading(true);
        balanceSheetRefresh(params, (message: string, resp: any) => {
            setIsLoading(false);
            setOnHold(true);
            if (resp && resp['data'] && resp['data']['data'] && resp['data']['data']['result']) {
                setGlBalanceSheetList(resp.data.data.result);
            } else {
                setGlBalanceSheetList([]);
            }

            if (resp && resp['data'] && resp['data']['data'] && resp['data']['data']) {
                setIsNotify(resp.data.data?.is_notify || false);
            }
        }, (message: string, resp: any) => {
            setGlBalanceSheetList([]);
            setIsLoading(false);
            toast.error(message);
        })
    }

    const _downloadReport = async () => {
        if (!contentRef.current) {
            return;
        }

        try {
            setIsDownloading(true)
            const pageWidth = 297;      // swapped
            const pageHeight = 210;     // swapped
            const margin = 4;
            const contentWidth = pageWidth - margin * 2;

            const pdf = new jsPDF('l', 'mm', 'a4');  // LANDSCAPE

            const dashboardElem = document.querySelector('.executive-dashboard');
            if (!dashboardElem) {
                toast.error(t("pdf.ref.no_found"));
                return;
            }
            const clone = dashboardElem.cloneNode(true) as HTMLElement;
            clone.style.position = 'absolute';
            clone.style.left = '-9999px';

            // Apply font styles only to the clone
            clone.style.fontFamily = 'helvetica';

            // Apply to all children in the clone
            const allElements = clone.querySelectorAll('*');
            allElements.forEach((el: any) => {
                el.style.fontFamily = 'helvetica';
                el.style.fontSize = '3px';
            });

            // Preparing the temp div
            const tempDiv = document.createElement('div');
            tempDiv.style.position = 'absolute';
            tempDiv.style.left = '-9999px';
            tempDiv.style.fontFamily = 'helvetica';
            tempDiv.style.fontWeight = '200';
            tempDiv.style.lineHeight = '1';
            // tempDiv.style.border = '1px solid black';

            tempDiv.appendChild(clone);
            document.body.appendChild(tempDiv);

            // Now selecting from tempDiv, not from the main DOM
            const tableHeaderSection = tempDiv.querySelector('.balance-sheet-table-header');
            const tableBodySection = tempDiv.querySelectorAll('.bs-table-body-row');

            const addCustomHeader = (doc: jsPDF, pageNum: number) => {
                // add new lines before header
                doc.setFont('helvetica', 'bold'); // Use helvetica for Arial-like look
                doc.setFontSize(16);
                doc.setTextColor(40);

                const heading1 = companyInfo?.business_name ?? "";
                const textWidth1 = doc.getTextWidth(heading1);
                const centerX1 = (pageWidth - textWidth1) / 2;
                doc.text(heading1, centerX1, 18);

                const heading = t("pdf.header2");
                const textWidth = doc.getTextWidth(heading);
                const centerX = (pageWidth - textWidth) / 2;
                doc.text(heading, centerX, 26);

            };

            addCustomHeader(pdf, 1);

            let currentY = 34;

            if (tableHeaderSection) {
                // Change the header text to "As of <date>"
                const currentMonthEnd = moment(`${+searchParams['year']['value']}-${searchParams['month']['value']}-01`).endOf('month').format('MM/DD/YYYY');
                const priorYearMonthEnd = moment(`${+searchParams['year']['value'] - 1}-${searchParams['month']['value']}-01`).endOf('month').format('MM/DD/YYYY');

                // Update header DOM before rendering to canvas
                const headerCols = tableHeaderSection.querySelectorAll('div.col-md-4');
                headerCols.forEach((el: any) => {
                    const currentStyle = el.getAttribute('style') || '';
                    el.setAttribute('style', currentStyle + ' padding-top: 5px !important; max-height: 1px !important; margin: 0 !important; line-height: 1 !important;');
                });

                if (headerCols.length === 3) {
                    // Center column: "As of <date>"
                    headerCols[1].innerHTML = `<h2 style="font-family: helvetica; font-size: 4px !important;">${t("pdf.as_of")} <br/> ${currentMonthEnd}</h2>`;
                    // Right column: "As of <date>"
                    headerCols[2].innerHTML = `<h2 style="font-family: helvetica; font-size: 4px !important;">${t("pdf.as_of")} <br/> ${priorYearMonthEnd}</h2>`;
                }

                const contentCanvas = await html2canvas(tableHeaderSection as HTMLElement, {
                    scale: 10,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                });

                const contentImgWidth = contentWidth;
                const contentImgHeight = (contentCanvas.height * contentWidth) / contentCanvas.width;

                if (contentImgHeight > pageHeight - currentY - margin) {
                    pdf.addPage();
                    addCustomHeader(pdf, 1);
                    currentY = margin;
                }

                // Center horizontally
                const x = (pageWidth - contentImgWidth) / 2;

                pdf.addImage(contentCanvas.toDataURL('image/png'), 'PNG', x, currentY, contentImgWidth, contentImgHeight);

                currentY += contentImgHeight;
            }

            for (let i = 0; i < tableBodySection.length; i++) {
                const row = tableBodySection[i] as HTMLElement;

                let currentStyle = row.getAttribute('style') || '';
                row.setAttribute('style', currentStyle + ' border: none !important;');

                row.querySelectorAll('.col-md-3 [class$="-sum"]').forEach((el: any) => {
                    let currentStyle = el.getAttribute('style') || '';
                    el.setAttribute('style', currentStyle + ' border: none !important;');
                });

                // Apply font and cell styles to all relevant child elements
                const allCells = row.querySelectorAll('.col-md-4, .col-md-3, h4, h2, div, span, strong, b');
                allCells.forEach((el: any) => {
                    let currentStyle = el.getAttribute('style') || '';
                    el.setAttribute('style', currentStyle + ' font-family: helvetica !important; padding: 0.8px !important; min-height: 4px !important; margin: 0 !important; line-height: 1 !important; font-weight: bold; text-align: left !important;');
                });
                

                // Fix: Ensure $ and value are together in a single line
                const currencyCells = row.querySelectorAll('h4, h2, strong, b');
                currencyCells.forEach(cell => {
                    // Only update if it contains a $ sign and a number
                    const currentStyle = cell.getAttribute('style') || '';
                    cell.setAttribute('style', currentStyle + 'font-family: helvetica !important; text-align: left !important; ');

                    if (cell.innerHTML.includes('$')) {
                        // Remove any line breaks or wrapping between $ and value
                        const text = (cell as HTMLElement).innerText.replace(/\n/g, '').replace(/\s+/g, ' ');
                        cell.innerHTML = text
                        // cell.innerHTML = cell.innerText.replace(/\n/g, '').replace(/\s+/g, ' ');
                    }
                });

                const rowCanvas = await html2canvas(row, {
                    scale: 10,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                });

                const rowImgWidth = contentWidth;
                const rowImgHeight = (rowCanvas.height * contentWidth) / rowCanvas.width;

                if (rowImgHeight > pageHeight - currentY - margin) {
                    pdf.addPage();
                    addCustomHeader(pdf, 1);
                    currentY = margin;
                }

                // Center horizontally
                const x = (pageWidth - rowImgWidth) / 2;

                pdf.addImage(rowCanvas.toDataURL('image/png'), 'PNG', x, currentY, rowImgWidth, rowImgHeight);

                currentY += rowImgHeight;
            }

            // Cleaning up the temporary element
            document.body.removeChild(tempDiv);

            const pdfOutput = pdf.output('blob');
            const pdfUrl = URL.createObjectURL(pdfOutput);
            const a = document.createElement('a');
            a.href = pdfUrl;
            a.download = `balance-sheet-${new Date().toISOString().slice(0, 10)}.pdf`;
            a.style.display = 'none';

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            URL.revokeObjectURL(pdfUrl);
            setIsDownloading(false);

        } catch (error) {
            console.error('Error generating PDF:', error);
            setIsDownloading(false);
        }
    }

    const _handleChangeSearchParam = (e: any, type: string) => {
        if (type === 'month') {
            setSearchParams({
                ...searchParams,
                'month': e
            })
        } else if (type === 'year') {
            setSearchParams({
                ...searchParams,
                'year': e
            })
        }
    }

    const getSettingsData = () => {
        fetchAccountSettingsData({ branch_id: +branchData['id'] }, (msg: string, resp: any) => {

        }, (msg: string, resp: any) => {

        })
    }

    const getLastDayOfMonth = (month: any, year: any) => {
        return new Date(year, month, 0).getDate();
    }

    const _handleShowViewRegister = (data: any, hasEditAccess: boolean) => {
        setTxnRegisterPayload({
            startDate: `${searchParams.year['value']}-${searchParams.month['value']}-01`,
            endDate: `${searchParams.year['value']}-${searchParams.month['value']}-${getLastDayOfMonth(searchParams.month['value'], searchParams.year['value'])}`,
            account: data['account_chart']['id'],
            hasEditAccess: isThirdPartyEnabled ? false : hasEditAccess
        })
        setIsShowViewRegister(true);
    }

    const _handleCloseViewRegister = () => {
        setIsShowViewRegister(false);
        fetchBalanceSheetList();
    }

    useEffect(() => {
        setOnHold(!!accountSettings.bs_refresh_in_progress)
    }, [accountSettings])

    useEffect(() => {
        const intervalId = setInterval(() => {
            getSettingsData();
        }, 5000);

        return () => clearInterval(intervalId);
    })

    return (
        <div className="main-container flex-grow-1" ref={contentRef}>
            <div className="container-fluid">
                <div className="page-title pb-4 pt-3">
                    <div className="row align-items-center">
                        <div className="col-sm-6 align-items-center d-flex">
                            <h1 className="h3 font-weight-700 mb-0 d-inline-flex">{t("title")}</h1>
                        </div>
                    </div>
                </div>
                {
                    // !isThirdPartyEnabled && isNotify ? (
                    //     <Alert variant={'info'}>
                    //         <i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i>&nbsp;&nbsp;
                    //         Please refresh the balance sheet to reflect new updates.
                    //     </Alert>
                    // ) : <></>
                }
                {
                    bsRefreshInOrogress !== 1 ? (
                        <>
                            <div className="filter-box-top">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="filter-wrap">
                                            <div className="filter-box">
                                                <Select
                                                    onChange={(e: any) => _handleChangeSearchParam(e, 'month')}
                                                    options={MONTHS}
                                                    defaultValue={searchParams['month']}
                                                    className={'zindex-10'}
                                                />
                                            </div>
                                            <div className="filter-box">
                                                <Select
                                                    onChange={(e: any) => _handleChangeSearchParam(e, 'year')}
                                                    options={lastYears(5)}
                                                    defaultValue={searchParams['year']}
                                                    className={'zindex-10'}
                                                />
                                            </div>

                                            <div className="filter-box">
                                                <button type="button" onClick={fetchBalanceSheetList} className="btn-primary btn btn-lg">{t("filter.generate_report")} &nbsp; <i className="fa fa-search" aria-hidden="true"></i></button> &nbsp;
                                                {
                                                    !isThirdPartyEnabled && glBalanceSheetList.length ? (
                                                        <button type="button" onClick={refreshBalanceSheetList} className="btn-warning btn btn-lg d-none">{t("filter.refresh")} &nbsp; <i className="fa fa-refresh" aria-hidden="true"></i></button>
                                                    ) : <></>
                                                }
                                            </div>
                                            {
                                                glBalanceSheetList.length ? (
                                                    <div className="filter-box text-end">
                                                        <button type="button" onClick={_downloadReport} className="btn-dark btn btn-lg">
                                                            {isDownloading ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> :
                                                                <div>
                                                                    {t("filter.export_pdf")} &nbsp;
                                                                    <i className="fa fa-download" aria-hidden="true"></i>
                                                                </div>}
                                                        </button>
                                                    </div>
                                                ) : <></>
                                            }

                                            <div className="filter-btn">
                                                <div className={`page-loader ${isLoading ? 'visible' : 'hidden'}`}>
                                                    <div className="loader"></div>
                                                </div>
                                                {
                                                    onHold ? (
                                                        <DotLoader text={t("filter.loader")} />
                                                    ) : <></>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="executive-dashboard table-design">
                                {
                                    glBalanceSheetList.length ? (
                                        <div className='row'>
                                            <div className="balance-sheet-table-header col-md-12">
                                                <div className="col-md-4"><h2></h2></div>
                                                <div className="col-md-4 text-center">
                                                    {/* <h2>Month ending</h2> */}
                                                    <h2>{t("table.header.current_month")}</h2>
                                                    <h2>
                                                        {moment(`${+searchParams['year']['value']}-${searchParams['month']['value']}-01`).endOf('month').format('MM/DD/YYYY')}
                                                    </h2></div>
                                                <div className="col-md-4 text-center">
                                                    {/* <h2>Prior Year Month ending</h2> */}
                                                    <h2>{t("table.header.prior_year")}</h2>
                                                    <h2>
                                                        {moment(`${+searchParams['year']['value'] - 1}-${searchParams['month']['value']}-01`).endOf('month').format('MM/DD/YYYY')}
                                                    </h2>
                                                </div>
                                            </div>
                                            <div className="balance-sheet-table-body col-md-12">
                                                {
                                                    glBalanceSheetList.map((data, index) => {

                                                        const { report_code } = data['account_chart'];
                                                        const shouldHideRow = ['VP', 'VP/IP', 'IP'].includes(report_code) && !data['prev_year_total_amount'] && !data['total_amount'] ? 'd-none' : '';
                                                        if (shouldHideRow == '') {
                                                            return (
                                                                <div className={`bs-table-body-row bs-table-body-${data['account_chart']['report_code']} ${shouldHideRow} resize-font`} key={index}>
                                                                    <div className="col-md-4">
                                                                        <h4 style={['VP', 'VP/IP', 'IP'].includes(data['account_chart']['report_code']) ? { marginLeft: '35px', whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word' } : { whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                                                                            {data['account_chart']['name']}
                                                                        </h4>
                                                                    </div>
                                                                    {
                                                                        !['GH', 'SH', 'SSH'].includes(data['account_chart']['report_code']) && (
                                                                            <>
                                                                                <div className="col-md-4 d-flex">
                                                                                    <div className="col-md-3 text-end">
                                                                                        {
                                                                                            ['VP', 'VP/IP', 'IP'].includes(data['account_chart']['report_code']) && (
                                                                                                (+data['total_amount'] == 0 || data['account_chart']['report_code'] != 'VP') ? (
                                                                                                    <h4 style={{ whiteSpace: "nowrap" }}>
                                                                                                        {data['total_amount'] >= 0 ? usdCurrencyFormat(data['total_amount'] || 0) : `(${usdCurrencyFormat(Math.abs(data['total_amount']))})`}
                                                                                                    </h4>
                                                                                                ) : (
                                                                                                    <h4 style={{ whiteSpace: "nowrap" }} onClick={() => _handleShowViewRegister(data, true)} className='clickable_link'>
                                                                                                        {data['total_amount'] > 0 ? usdCurrencyFormat(data['total_amount']) : `(${usdCurrencyFormat(Math.abs(data['total_amount']))})`}
                                                                                                    </h4>
                                                                                                )
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                    <div className="col-md-3 text-end">
                                                                                        {
                                                                                            data['account_chart']['report_code'] === 'SST' && (
                                                                                                <h4 className={data['account_chart']['report_code'] + '-sum'}>{data['total_amount'] >= 0 ? usdCurrencyFormat(data['total_amount'] || 0) : `(${usdCurrencyFormat(Math.abs(data['total_amount']))})`}</h4>
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                    <div className="col-md-3 text-end">
                                                                                        {
                                                                                            data['account_chart']['report_code'] === 'ST' && (
                                                                                                <h4 className={data['account_chart']['report_code'] + '-sum'}>{data['total_amount'] >= 0 ? usdCurrencyFormat(data['total_amount'] || 0) : `(${usdCurrencyFormat(Math.abs(data['total_amount']))})`}</h4>
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                    <div className="col-md-3 text-end">
                                                                                        {
                                                                                            data['account_chart']['report_code'] === 'GT' && (
                                                                                                <h4 className={data['account_chart']['report_code'] + '-sum'}>{data['total_amount'] >= 0 ? usdCurrencyFormat(data['total_amount'] || 0) : `(${usdCurrencyFormat(Math.abs(data['total_amount']))})`}</h4>
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4 d-flex">
                                                                                    <div className="col-md-3 text-end">
                                                                                        {
                                                                                            ['VP', 'VP/IP', 'IP'].includes(data['account_chart']['report_code']) && (
                                                                                                <h4>{data['prev_year_total_amount'] >= 0 ? usdCurrencyFormat(data['prev_year_total_amount'] || 0) : `(${usdCurrencyFormat(Math.abs(data['prev_year_total_amount']))})`}</h4>
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                    <div className="col-md-3 text-end">
                                                                                        {
                                                                                            data['account_chart']['report_code'] === 'SST' && (
                                                                                                <h4 className={data['account_chart']['report_code'] + '-sum'}>
                                                                                                    {data['prev_year_total_amount'] >= 0 ? usdCurrencyFormat(data['prev_year_total_amount'] || 0) : `(${usdCurrencyFormat(Math.abs(data['prev_year_total_amount']))})`}
                                                                                                </h4>
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                    <div className="col-md-3 text-end">
                                                                                        {
                                                                                            data['account_chart']['report_code'] === 'ST' && (
                                                                                                <h4 className={data['account_chart']['report_code'] + '-sum'}>{data['prev_year_total_amount'] >= 0 ? usdCurrencyFormat(data['prev_year_total_amount'] || 0) : `(${usdCurrencyFormat(Math.abs(data['prev_year_total_amount']))})`}</h4>
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                    <div className="col-md-3 text-end">
                                                                                        {
                                                                                            data['account_chart']['report_code'] === 'GT' && (
                                                                                                <h4 className={data['account_chart']['report_code'] + '-sum'}>{data['prev_year_total_amount'] >= 0 ? usdCurrencyFormat(data['prev_year_total_amount'] || 0) : `(${usdCurrencyFormat(Math.abs(data['prev_year_total_amount']))})`}</h4>
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        ) ||
                                                                        (
                                                                            <>
                                                                                <div className="col-md-4 d-flex">
                                                                                    <div className="col-md-3">
                                                                                        <h4></h4>
                                                                                    </div>
                                                                                    <div className="col-md-3">
                                                                                        <h4></h4>
                                                                                    </div>
                                                                                    <div className="col-md-3">
                                                                                        <h4></h4>
                                                                                    </div>
                                                                                    <div className="col-md-3">
                                                                                        <h4></h4>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4 d-flex">
                                                                                    <div className="col-md-3">
                                                                                        <h4></h4>
                                                                                    </div>
                                                                                    <div className="col-md-3">
                                                                                        <h4></h4>
                                                                                    </div>
                                                                                    <div className="col-md-3">
                                                                                        <h4></h4>
                                                                                    </div>
                                                                                    <div className="col-md-3">
                                                                                        <h4></h4>
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    }

                                                                </div>
                                                            );
                                                        }

                                                    })
                                                }                                                
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="text-center">
                                            <span>{t("table.empty")}</span>
                                        </div>
                                    )
                                }
                            </div>
                        </>
                    ) : <></>
                }

            </div>

            <SAlert
                show={showConfirm}
                icon={'warning'}
                showCancel={true}
                confirmBtnText={t("alert.regenerate.confirm")}
                cancelBtnText={t("alert.regenerate.cancel")}
                confirmBtnBsStyle={'danger'}
                cancelBtnBsStyle={"secondary"}
                title={t("alert.regenerate.title")}
                msg={t("alert.regenerate.msg")}
                onConfirm={refreshBalanceSheetList}
                onCancel={() => setShowConfirm(false)}
            />

            {
                isShowViewRegister ?
                    <ViewRegisterModal
                        show={isShowViewRegister}
                        onHide={() => _handleCloseViewRegister()}
                        startDate={txnRegisterPayload.startDate}
                        endDate={txnRegisterPayload.endDate}
                        account={txnRegisterPayload.account}
                        hasEditAccess={txnRegisterPayload.hasEditAccess}
                        header={t("modal.header", { monthYear: moment(searchParams.year['value'] + '-' + searchParams.month['value'] + '-01').format('MMM, YYYY') })}
                        emptyMsg={t("modal.emptyMsg")}
                        showBeginningAndEndingBalance={true}
                    /> : <></>
            }
        </div>

    )
}

export default BalanceSheet;